(function($, undefined) {
	'use strict';

	var initSlider = function() {
		var slider = $('.product-detail__img-slider');
		
		slider.on('init', function(event, slick) {
			slider.find('.product-detail__img').removeClass('hidden');
		});

		slider.each(function() {
			if ($(this).hasClass('popup')) {
				$(this).slick({
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows: true,
					dots: false,
					fade: true,
					prevArrow: $('.product-detail__img-popup-slider-arrow.prev'),
					nextArrow: $('.product-detail__img-popup-slider-arrow.next'),
					asNavFor: $('.product-detail__img-slider:not(.popup)')
				});
			} else {
				$(this).slick({
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows: false,
					dots: true,
					fade: true,
					asNavFor: $('.product-detail__img-slider.popup'),
					appendDots: $('.product-detail__img-dots'),
				});
			}
		});
	};

	var initAuthorsSlider = function() {
		var slider = $('.product-detail__authors-slider');
		var ctn = $('.product-detail__authors-ctn');
		
		slider.on('init', function(event, slick) {
			slider.find('.author').removeClass('hide');
		});

		slider.slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			dots: false,
			fade: true,
			draggable: false,
			prevArrow: ctn.find('.arrow-btn.prev'),
			nextArrow: ctn.find('.arrow-btn.next')
		});
	};

	var init = function() {
		if ($('.product-detail__img-slider').find('.product-detail__img').length > 1) {
			initSlider();
		}
		if ($('.product-detail__authors-slider').find('.author').length > 0) {
			if ($('.product-detail__tab.authors.selected').length > 0) {
				initAuthorsSlider();
			} else {
				$('.product-detail__tab.authors').click(function() {
					if ($('.product-detail__authors-slider:not(.slick-slider)')) {
						initAuthorsSlider();
					}
				});
			}
		}
	};
	
	$(window).ready(function () {
		init();
	});
	
})(jQuery);
